<template>
  <div class="breadCrumb">
    <div><h3>Approvisionnements</h3></div>
    <div>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">Gestion Stock</li>
          <li class="breadcrumb-item active" aria-current="page">Approvisionnements</li>
        </ol>
      </nav>
    </div>
  </div>

  <div class="tab-top">
    <div class="d-flex justify-content-end gap-2">
      <button class="btn btn-primary" @click="creation()">
        <i class="bi bi-plus-circle"></i> Création
      </button>

      <div class="dropdown">
        <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
          Actions
        </button>
        <ul class="dropdown-menu">
          <li><a class="dropdown-item" href="#" @click.prevent="">Exporter</a></li>
        </ul>
      </div>
    </div>
  </div>

  <div class="card p-3">
    <div class="row justify-content-end">
      <div class="col-md-2 m-2">
        <label class="form-label">Rechercher</label>
        <input v-model="searchQuery" type="text" class="form-control" placeholder="Rechercher un médicament">
      </div>

      <div class="col-md-2 m-2">
        <label class="form-label">Items Par page</label>
        <select v-model="itemsperpage" class="form-select">
          <option v-for="item in itemsPerPageT" :key="item" :value="item">{{ item }}</option>
        </select>
      </div>

      <div class="col-md-3 m-2">
        <label class="form-label">Trier par</label>
        <select v-model="orderBy" class="form-select">
          <option v-for="(val, key) in orderByTabs" :key="key" :value="val">{{ key }}</option>
        </select>
      </div>

      <div class="col-md-2 m-2">
        <label class="form-label">Ordre</label>
        <select v-model="sortOrder" class="form-select">
          <option v-for="(val, key) in sortOrders" :key="key" :value="val">{{ key }}</option>
        </select>
      </div>
    </div>

    <!-- Tableau -->
    <div class="table-responsive">
      <table class="table table-hover table-bordered">
        <thead class="table-primary">
          <tr>
            <th>#</th>
            <th>N° Appro</th>
            <th>Date</th>
            <th>Médicament</th>
            <th>Conditionnement</th>
            <th>Qté</th>
            <th>Par Unité</th>
            <!--<th>Total Unités</th>-->
            <th>Prix Achat</th>
            <th>Prix Vente</th>
            <th>Total Achat</th>
            <th>Total Vente</th>
            <th>Péremption</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(appro, index) in filteredApprovisionnements" :key="appro.id" :class="getExpirationClass(appro.datePeremption)">
            <td>{{ index + 1 + (currentPage - 1) * itemsperpage }}</td>
            <td>{{ appro.numeroLot }}</td>
            <td>{{ formatDate(appro.dateApprovisionnement) }}</td>
            <td>{{ appro.medicament?.nom }}</td>
            <td>{{ appro.conditionnement?.nom }}</td>
            <td>{{ appro.quantite }}</td>
            <td>{{ appro.nombreParUnite || appro.conditionnement?.nombreParUnite }}</td>
           <!-- <td>{{ appro.totalUnites }}</td>-->
            <td>{{  formatPrice(appro.prixAchat) }}</td>
            <td>{{ formatPrice(appro.prixVente) }}</td>
            <td>{{ formatPrice(appro.montantTotalAchat) }}</td>
            <td>{{ formatPrice(appro.montantTotalVente) }}</td>
            <td>{{ formatDate(appro.datePeremption) }}</td>
            <td class="text-center">
              <div class="dropdown">
                <button class="btn btn-sm btn-outline-primary dropdown-toggle" type="button" data-bs-toggle="dropdown">
                  ⋮
                </button>
                <ul class="dropdown-menu">
                  <li><a class="dropdown-item" @click="modifier(appro.id)">Modifier</a></li>
                  <li><a class="dropdown-item text-danger" @click="supprimer(appro.id)">Supprimer</a></li>
                </ul>
              </div>
            </td>
          </tr>
          <tr v-if="filteredApprovisionnements.length === 0">
            <td colspan="13" class="text-center">Aucune donnée disponible</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination -->
    <nav>
      <ul class="pagination justify-content-end">
        <li class="page-item" :class="{ disabled: currentPage === 1 }">
          <button class="page-link" @click="changePage(currentPage - 1)">Précédent</button>
        </li>
        <li
          v-for="page in totalPages"
          :key="page"
          class="page-item"
          :class="{ active: page === currentPage }"
        >
          <button class="page-link" @click="changePage(page)">{{ page }}</button>
        </li>
        <li class="page-item" :class="{ disabled: currentPage === totalPages }">
          <button class="page-link" @click="changePage(currentPage + 1)">Suivant</button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import api from '@/api';
import dayjs from 'dayjs';

export default {
  data() {
    return {
      searchQuery: '',
      itemsperpage: 10,
      currentPage: 1,
      totalItems: 0,
      approvisionnements: [],
      itemsPerPageT: [5, 10, 20],
      orderBy: 'appr.createdAt',
      sortOrder: 'desc',
      orderByTabs: {
        Date: 'createdAt',
        Médicament: 'medicament.nom',
        Quantité: 'quantite',
        Péremption: 'datePeremption'
      },
      sortOrders: {
        croissant: 'asc',
        décroissant: 'desc'
      }
    };
  },
  computed: {
    filteredApprovisionnements() {
    return this.approvisionnements
      .filter(item => !item.isDeleted) // Exclure les supprimés
      .filter(item => {
        if (!this.searchQuery) return true;
        return (item.medicament?.nom || '')
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase());
      });
  },
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsperpage);
    }
  },
  methods: {
    formatDate(date) {
      return date ? dayjs(date).format('DD-MM-YYYY') : '';
    },
    creation() {
      this.$router.push({ name: 'create_approvisionnement' });
    },
    modifier(id) {
      this.$router.push({ name: 'edit_approvisionnement', params: { id } });
    },
    async supprimer(id) {
      const confirmDelete = confirm("Confirmer la suppression ?");
      if (!confirmDelete) return;
      await api.deleteItem('approvisionnements', id);
      this.getApprovisionnements();
    },
    changePage(page) {
      if (page > 0 && page <= this.totalPages) {
        this.currentPage = page;
        this.getApprovisionnements();
      }
    },
   formatPrice(value) {
    if (!value && value !== 0) return '';
    const number = parseFloat(value);
    return number.toLocaleString('fr-FR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
  },
    getExpirationClass(date) {
  if (!date) return '';

  const today = dayjs();
  const expirationDate = dayjs(date);

  if (expirationDate.isBefore(today, 'day')) {
    return 'table-danger'; 
  }

  const diffInMonths = expirationDate.diff(today, 'month', true);
  if (diffInMonths <= 3) {
    return 'table-warning'; 
  }

  return ''; 
}
,
    isNearExpiration(date) {
   if (!date) return false;
     const today = dayjs();
     const expirationDate = dayjs(date);
     return expirationDate.diff(today, 'month', true) <= 3;
     },
    async getApprovisionnements() {
      try {
        const res = await api.getItems('approvisionnements', {
          orderBy: this.orderBy,
          itemsperpage: this.itemsperpage,
          sortOrder: this.sortOrder,
          page: this.currentPage,
          search: this.searchQuery
        });
        this.approvisionnements = (res.data?.data || []).map(item => ({
        ...item,
        isDeleted: item.isDeleted 
       }));
        
        
        this.totalItems = res.data?.meta?.total_records || 0;
      } catch (e) {
        console.error("Erreur chargement:", e);
      }
    }
  },
  watch: {
    searchQuery() {
      this.currentPage = 1;
      this.getApprovisionnements();
    },
    itemsperpage() {
      this.currentPage = 1;
      this.getApprovisionnements();
    },
    orderBy() {
      this.getApprovisionnements();
    },
    sortOrder() {
      this.getApprovisionnements();
    }
  },
  created() {
    this.getApprovisionnements();
  }
};
</script>

<style scoped>
.table th,
.table td {
  text-align: center;
  vertical-align: middle;
}
.pagination .page-item .page-link {
  color: #007bff;
}
.pagination .page-item.active .page-link {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
}
.breadCrumb {
  display: flex;
  justify-content: space-between;
  padding: 8px;
}
</style>
